<template>
  <div class="partners">
    <div class="container partners__container">
        <div class="row">
            <div class="col-md-12">
                <div class="partners__header">
                    <h2 class="container__title partners__title">{{$store.getters.t('partners_title')}}</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">

                <template v-if="loading">
                    <div class="d-flex common-block">
                        <div class="LoaderBalls">
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <template v-if="partners.length > 3">
                        <swiper class="partners-slider" :options="partnerSlideOptions">
                            <template v-for="(partner, idx) in partners">
                                <swiper-slide
                                    class="partners-slider__item"
                                    :key="idx"
                                >
                                    <div class="partner-slider__ico">
                                        <img
                                            :src="partner.main_image.path"
                                            :alt="partner"
                                        />
                                    </div>
                                </swiper-slide>
                            </template>
                        </swiper>
                    </template>
                    <template v-else>
                        <div class="d-flex partners-grid">
                            <template  v-for="(partner, idx) in partners">
                                <div class="partners-slider__item" :key="idx">
                                    <div class="partner-slider__ico">
                                        <img
                                            :src="partner.main_image.path"
                                        />
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </template>

            </div>
        </div>

    </div>
  </div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { getContentBlock } from './api/get-content-block'

const defaultPartners = 
[
    { main_image: { path: '/assets/images/p-f.png' } }, 
    { main_image: { path: '/assets/images/royal-canin.png' } }, 
    { main_image: { path: '/assets/images/p-th.png' } }, 
    { main_image: { path: '/assets/images/p-fr.jpg' } }, 
    { main_image: { path: '/assets/images/p-fv.png' } },
    { main_image: { path: '/assets/images/p-sx.jpg' } }, 
    { main_image: { path: '/assets/images/p-sv.png' } },
    { main_image: { path: '/assets/images/p-ei.jpg' } }, 
    { main_image: { path: '/assets/images/vet-logo2.png' } }
]

export default {
  name: 'Partners',
  data() {
    return {
      partnerSlideOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        speed: 1500,
          loop: true,
          autoplay: {
              delay: 1500,
          },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      },
        config: [],
        loading: false
    }
  },

    async mounted(){
        await this.getPartners()
    },
    CONTEN_BLOCK_NAME: 'main_partners',   
    computed: {

      partners(){
          if( ! this.config.length ) return []
          return this.config
      }

    },

    methods: {

      async getPartners(){

        this.loading = true
        let { CONTEN_BLOCK_NAME } = this.$options

        getContentBlock( CONTEN_BLOCK_NAME )
            .then( 
                ( { items = [] } ) => {
                    if( items.length ) {
                        this.config = items
                        .filter( it => it.main_image && it.main_image.path )
                        .map(
                            it => {
                                it.main_image.path = `/storage/${it.main_image.path}`
                                return it
                            }
                        )
                    }
                    if( ! items.length ) this.config = defaultPartners
                    this.loading = false
                }
            )
            .catch( 
                e => {
                    this.config = defaultPartners
                    this.loading = false
                }
            )

      }

    },
  watch: {
    config() {
        setTimeout(() => {
            this.loading = false
        }, 300)
    }
  },
  components: { Swiper, SwiperSlide }
}
</script>

<style lang="scss">

.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}


.common-block{
    justify-content: center;
    align-items: center;
    font-size: 30px;
    text-align: center;
    height: 200px;
}

.partners {
  padding: 35px 0;
  background-color: #ffffff;
  &__header {
    position: relative;
  }
  &__title {
    margin-bottom: 0;
  }

    &__navigation {
        display: flex;
        justify-content: center;
        margin-top: 0;
        position: absolute;
        top: 0;
        right: 15px;

        .swiper-button-prev,
        .swiper-button-next {
            position: static;
            outline: none;
            background: #EAF1FC;
            border-radius: 20px;
            padding: 15px 20px;
            width: auto;
            height: auto;
            margin: 0 5px;
        }

        .swiper-button-prev {
            &::after {
                content: '';
                background: url('/assets/images/arrow-r.svg') no-repeat center;
                background-size: cover;
                width: 15px;
                height: 10px;
                transform: rotate(-180deg);
            }
        }

        .swiper-button-next {
            &::after {
                content: '';
                background: url('/assets/images/arrow-r.svg') no-repeat center;
                background-size: cover;
                width: 15px;
                height: 10px;
            }
        }
    }
}
.partners-slider {
  width: 100%;
  height: 100%;
  padding: 50px 3px !important;
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }
}
.partner-slider__ico {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
    padding: 15px;
}

.partners-grid{
    margin: 20px 0;
    column-gap: 30px;

    .partners-slider__item{
        width: 100%;
        max-width: 25%;
    }

    .partner-slider__ico{
        width: 100%;
        height: 100%;
    }

    img{
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }

}

@media screen and( max-width: 768px ){
    .partners-grid{
        column-gap: 10px;
        .partners-slider__item{
            max-width: 33.33%;
        }
    }
}

</style>
